'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('LoginCtrl', LoginCtrl);

  LoginCtrl.$inject = ['$scope', '$stateParams', '$sessionStorage', '$timeout', '$sce', 'authenticationSvc', 'windowSvc', 'msAuth', 'msConfig', 'userSvc', 'domainSvc', 'onboardingRouter', 'eventTrackingSvc'];

  function LoginCtrl($scope, $stateParams, $sessionStorage, $timeout, $sce, authenticationSvc, windowSvc, msAuth, msConfig, userSvc, domainSvc, onboardingRouter, eventTrackingSvc) {
    // NOSONAR
    var loginModes;
    var checkedEmailAddress = null;
    $scope.user = {};
    $scope.flip = false;
    $scope.memberType = null;
    $scope.forgotPasswordLink = domainSvc.getAppDomain() + '/login/reset';
    $scope.spInitiatedSSOUrl = $sce.trustAsResourceUrl(windowSvc.getSpInitiatedSSOUrl());
    $scope.checkEmailAddress = _checkEmailAddress;
    $scope.login = _login;

    $scope.$watch('user', function () {
      $scope.invalid = false;

      if ($scope.user.email !== checkedEmailAddress) {
        $scope.memberType = null;
      }
    }, true);

    _activate();

    function _activate() {
      msConfig('loginModes').then(function (value) {
        loginModes = value;
        if (msAuth.isLoggedIn()) {
          if ($stateParams['mfa']) {
            onboardingRouter.navigateMfaAuthCode($stateParams);
            return;
          }
          userSvc.getUser().then(function (user) {
            // If user is bh-20 direct user to appv2 SSO landing for requirement fulfillment
            if (user.clientOfferingVersion === 'BH2_0') {
              windowSvc.goToAppV2OnboardingLanding();
              return;
            }
            if (!_navAppConnectivityMode(user, loginModes)) {
              if ($stateParams.redirecturl) {
                $sessionStorage.redirectUrl = $stateParams.redirecturl + document.location.hash;
              }
              onboardingRouter.goToNextStep();
            }
          });
        }
      });
    }

    function _checkEmailAddress() {
      if (!$scope.form.$valid) {
        $scope.form.email.$setDirty();
        return;
      }
      if (typeof $scope.user.email === 'undefined') {
        $timeout(function () {
          _checkEmailAddress();
        }, 500);
        return;
      }
      checkedEmailAddress = $scope.user.email;
      authenticationSvc.memberEmailCheck($scope.user.email).then(function (response) {
        var memberType = response.data.clientOfferingVersion ? response.data.clientOfferingVersion : 'MY1_0';
        $scope.memberType = memberType;

        // If is BH2_0 member post email address to SpInitiatedSSO flow
        // - See hidden form in logincard.pug
        if (memberType === 'BH2_0') {
          document.getElementById('SpInitiatedSSOForm').submit();
        }
      });
    }

    function _login() {
      if (!$scope.form.$valid) {
        $scope.form.email.$setDirty();
        $scope.form.password.$setDirty();
        return;
      }
      $scope.form.processing = true;
      $scope.invalid = false;
      authenticationSvc.login($scope.user, moment.tz.guess()).then(_onLoginSuccess, _onLoginError)['finally'](function () {
        $scope.form.processing = false;
      });
    }

    function _onLoginSuccess(resp) {
      if (resp.data.pwExpired) {
        onboardingRouter.goToState('password', { isPasswordExpiration: true });
        return;
      }
      var user = resp.data;
      eventTrackingSvc.fireEvent('engagement', 'login', 'web');
      if (!_navAppConnectivityMode(user, loginModes)) {
        // if this is a multi-factor auth request
        if ($stateParams['mfa']) {
          onboardingRouter.navigateMfaAuthCode({ redirecturl: $stateParams.redirecturl });
          return;
        }
        if ($stateParams.redirecturl) {
          // we got a redirection header, we should go there
          onboardingRouter.navigateRedirect({
            redirecturl: authenticationSvc.getFullyQualifiedRedirectUrl($stateParams.redirecturl + document.location.hash)
          });
          return;
        }
        onboardingRouter.goToNextStep();
      }
    }

    function _onLoginError(err) {
      $scope.invalidCopy = 'login.error';
      if (err.data && err.data.errorCode && err.data.errorCode === 'ACCESS_CODE_DISABLED') {
        $scope.invalidCopy = 'login.disabledAccessCode';
      } else if (err.data && err.data.errorCode && err.data.errorCode === 'EXCEEDED_MAX_FAILED_LOGIN_ATTEMPTS') {
        onboardingRouter.goToState('reset', { locked: true });
      } else if (err.data && err.data.errorCode && err.data.errorCode === 'INVALID_USERNAME_OR_PASSWORD') {
        $scope.invalidCopy = 'login.invalid';
      }
      $scope.form.email.$setPristine();
      $scope.form.password.$setPristine();
      $scope.invalid = true;
    }

    //this method is used to see if the login page was navigated to
    //via an app connectivity program.  As we implement OAUTH2, this will go away
    function _getAppConnectivityMode(lm) {
      if ($stateParams.organization && $stateParams.prg && lm && lm.organizations) {
        return _.find(lm.organizations, function (o) {
          return o.name === $stateParams.organization && o.program === $stateParams.prg;
        });
      }
      return false;
    }

    //this method is used to navigate if the login page was navigated to
    //via an app-connectivity program page. As we implement OAUTH2, this will go away
    function _navAppConnectivityMode(user, loginModes) {
      //fetch the connectionModeOrg to ensure it's valid and loaded before nav
      var connectionModeOrg = _getAppConnectivityMode(loginModes);
      if (connectionModeOrg && connectionModeOrg.callbackUrl) {
        //redirect to the app-connectivity url indicated in this environment.
        var callbackUrl = connectionModeOrg.callbackUrl + '?native_user_id=' + user.id;
        if ($stateParams.ownerId) {
          //if the app-connectivity source provided an ownerId param, forward it back to callbackUrl
          //for aetna quartet mode
          callbackUrl = callbackUrl + '&ownerId=' + $stateParams.ownerId;
        }
        windowSvc.windowNavigate(callbackUrl);
        return true;
      } else {
        return false;
      }
    }
  }
})();